import { useParams } from "react-router-dom";
import { useBooksStore } from "../state/BooksStore";
import StarRating from "../Components/StarRating";

export default function BookDetail() {
  const { id } = useParams();
  const book = useBooksStore((s) => s.getBookById(id));

  if (!book) {
    return (
      <main style={{ padding: 24, fontFamily: "system-ui, sans-serif" }}>
        <h2>Book not found</h2>
        <p>Invalid ID: {id}</p>
      </main>
    );
  }

  return (
    <main
      style={{
        maxWidth: 640,
        margin: "24px auto",
        padding: "0 16px",
        fontFamily: "system-ui, sans-serif",
        color: "#0f172a",
      }}
    >
      <h1 style={{ marginBottom: 4 }}>{book.title}</h1>
      <div style={{ color: "#475569", fontSize: 14 }}>
        by {book.author || "Unknown"}
      </div>

      <div style={{ marginTop: 12 }}>
        <StarRating value={book.rating || 0} size={20} />
      </div>

      <div style={{ marginTop: 12, fontSize: 14, color: "#475569" }}>
        <div>
          <b>Status:</b> {book.status}
        </div>
        <div>
          <b>Genres:</b>{" "}
          {book.genres?.length ? book.genres.join(", ") : "—"}
        </div>
        <div>
          <b>Added:</b> {new Date(book.createdAt).toLocaleString()}
        </div>
      </div>
    </main>
  );
}
